


import Vue from 'vue'
import * as d3 from 'd3'
import { ChartDataPoint } from '../types'

export default Vue.extend({
  name: 'Tooltip',
  data: () => ({ tooltip: {} as HTMLDivElement }),
  mounted() {
    this.addChartTooltip()
  },
  methods: {
    addChartTooltip(): void {
      this.tooltip = d3
        .select('body')
        .append('div')
        .attr('class', 'purchase-intervals-chart-tooltip')
        .node()!
    },
    showBarTooltip(event: MouseEvent, dataPoint: ChartDataPoint): void {
      const barEl = d3
        .select('[data-role="DataSeriesBars"] rect')
        .node()! as SVGRectElement
      const xOffset = barEl.getBoundingClientRect().width / 2
      const yOffset = -5
      this.showTooltip(event, dataPoint, xOffset, yOffset)
    },
    showDataPointTooltip(event: MouseEvent, dataPoint: ChartDataPoint): void {
      const circleEl = d3
        .select('[data-role="DataSeriesLine"] circle')
        .node()! as SVGCircleElement
      const xOffset = circleEl.getBoundingClientRect().width / 2
      const yOffset = -(circleEl.getBoundingClientRect().width / 2 + 1)
      this.showTooltip(event, dataPoint, xOffset, yOffset)
    },
    showTooltip(
      event: MouseEvent,
      dataPoint: ChartDataPoint,
      xOffset: number = 0,
      yOffset: number = 0
    ) {
      d3.select(this.tooltip)
        .style('visibility', 'hidden')
        .style('display', 'block')

      d3.select(this.tooltip).html(
        `<div>
            <p><strong>Within ${dataPoint.xValue} days</strong></p>
            <p><strong>${dataPoint.yBarValue.toFixed(
              1
            )}%</strong> of customer repurchased</p>
            <p><strong>${dataPoint.yLineValue.toFixed(
              1
            )}%</strong> of all repeat orders had occured</p>
          </div>`
      )

      const eventTarget = event.target as HTMLElement
      const eventTargetRect = eventTarget.getBoundingClientRect()
      const tooltipRect = this.tooltip.getBoundingClientRect()

      d3.select(this.tooltip)
        .style(
          'left',
          `${
            window.scrollX + eventTargetRect.x - tooltipRect.width / 2 + xOffset
          }px`
        )
        .style(
          'top',
          `${
            window.scrollY + eventTargetRect.y - tooltipRect.height + yOffset
          }px`
        )
        .style('visibility', 'visible')
    },
    hideTooltip(): void {
      d3.select(this.tooltip).style('display', 'none')
    },
  },
})
